import React from 'react';
import Layout from '../layout';
import {css} from "emotion";
import history from '../../utils/history';
import IconEasyBoat from '../common/material-easy-ui/icon/IconEasyBoat';
const FormListPage = (props) =>{

  const goToBoatForm = () =>{
      history.push({pathname:'/navire-formulaire'})
  }

  return(
    <Layout location={props.location}>
        <div className={css`max-width:678px;margin:0 auto`}>
        <div onClick={goToBoatForm} className={css`&:hover{
          -moz-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -webkit-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          -o-box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);
          box-shadow: 3px 3px 14px 0px rgba(41, 53, 74,0.1);};
          cursor:pointer;background-color:white;height:100px;margin-top:20px;display:flex;align-items:center;box-sizing:border-box;padding-left:20px;padding-right:20px;`}>
          <div className={css`background-color:#0084C6;height:50px;width:50px;display:flex;align-items:center;justify-content:center;border-radius:10px`}>
          <IconEasyBoat color={'white'} size={40}/>
          </div>
          <div className={css`flex:1;margin-left:30px;font-weight:600;color:#0084C6`}>
            <div>LOCATION DE NAVIRE</div>
            <div className={css`font-size:13px;margin-top:10px;color:#3f4d6e`}>Acceder au formulaire de location de navires</div>
          </div>
        </div>

      </div>
    </Layout>
  )
}

export default FormListPage;
